<template>
    <div
      class="headWrap"
      style="position: fixed;top: 0;z-index: 1;background: #fff;box-shadow: -6px 2px 17px 0px rgba(87,138,255,0.1);">
      <div class="logo" style="margin: 0 auto;background: #fff;">
        <div style="height: 70px;display: flex;align-items: center;padding: 0 80px;background: #fff;">
          <img src="../../assets/images/logo2.png" style="width: 144px;height: 40px;">
          <img style="width: 150px;margin-left: 40px;cursor: pointer;" src="https://open.work.weixin.qq.com/service/img?id=ww1ec99764ed843f3f&t=isp&c=white&s=large" srcset="https://open.work.weixin.qq.com/service/img?id=ww1ec99764ed843f3f&t=isp&c=white&s=large@2x 2x" referrerpolicy="unsafe-url" alt="企业微信">
        </div>
      </div>

      <div class="nav">
        <div class="navItem" v-for="item in navData" :key="item.title" :class="{active: item.title === active}">
            <span @click="toProduct(item.path)" class="title">{{item.title}} <img src="../../assets/images/jt.png" class="arrow" v-if="item.children" /></span>
            <div class="dropDown" v-if="item.children">
                <div @click="toProduct(subItem.path)" class="subItem" v-for="subItem in item.children" :key="subItem.title"><img class="icon" :src="subItem.icon" />{{subItem.title}}</div>
            </div>
          </div>
          <!-- <div class="navItem">
            <span class="title">首页</span>
          </div>
          <div class="navItem">
            <span class="title">产品 <img src="../../assets/images/jt.png" class="arrow" /></span>
            <div class="dropDown">
                <div class="subItem"><img class="icon" src="../../assets/images/icon_mp.png" />码客通名片</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_xcx.png" />码客查小程序</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_scrm.png" />码客通SCRM</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_mkc.png" />码客查APP</div>
            </div>
          </div>
          <div class="navItem">
            <span class="title">场景案例 <em class="arrow"></em></span>
            <div class="dropDown">
                <div class="subItem"><img class="icon" src="../../assets/images/icon_mp.png" />码客通名片</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_xcx.png" />码客查小程序</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_scrm.png" />码客通SCRM</div>
                <div class="subItem"><img class="icon" src="../../assets/images/icon_mkc.png" />码客查APP</div>
            </div>
          </div>
          <div class="navItem">
            <span class="title">行业方案 </span>
          </div>
          <div class="navItem">
            <span class="title">关于我们 </span>
          </div>
          <div class="navItem">
            <span class="title">新闻资讯</span>
          </div> -->
        </div>
    </div>
</template>
<script>
  export default{
    data() {
      return {
        navData: [
          {
            title:'首页',
            path: '/'
          },
          {
            title:'产品',
            children: [
              {
                title:'码客通名片',
                icon: require('../../assets/images/icon_mp.png'),
                path: '/Card'

              },
              {
                title:'码客查小程序',
                icon: require('../../assets/images/icon_xcx.png'),

              },
              {
                title:'码客通SCRM',
                icon: require('../../assets/images/icon_scrm.png'),
                path: '/Mkt'
              },
              {
                title:'码客查APP',
                icon: require('../../assets/images/icon_mkc.png'),
                 path: '/Mkc'
              },
            ]
          },
          {
            title:'场景案例',
          },
          {
            title:'行业方案',
          },
          {
            title:'关于我们',
          },
          {
            title:'新闻资讯',
          },
        ]
      }
    },
    props:{
      active: {
        type: String,
        default: ''
      }
    },
    methods: {
      toProduct(path) {
        this.$router.push({
          path: path
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.headWrap{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.nav{
  width: 70%;
  .navItem{
    float: left;
    position: relative;
    margin-right: 60px;
    border-bottom: 4px solid transparent;
    .title{
      display: block;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2329;
      padding: 0 20px 10px;
      cursor: pointer;
      position: relative;
      height: 65px;
      box-sizing: border-box;
      line-height: 65px;
      .arrow{
        width: 8px;
        height: 5px;
        margin-left: 4px;
        display: inline-block;
        background: url("../../assets/images/jt.png");
        background-size: 100% 100%;
      }

    }
    &:hover{
        border-bottom: 4px solid rgba(0, 183, 170, 1);

     }
    &.active{
        border-bottom: 4px solid rgba(0, 183, 170, 1);
     }
    .dropDown{
      background: #fff;
      position: absolute;
      top: 69px;
      padding: 30px 30px 3px 30px;
      left: 50%;
      transform: translateX(-50%);
      display: none;
      width: 360px;
      box-sizing: border-box;
      vertical-align: middle;
      border-radius: 8px;
      box-shadow: 0px 0px 4px 0px #D8ECEB;
    }

    &:hover .dropDown {
      display: block;
    }
    &:hover .title .arrow{
          background: url("../../assets/images/jt2.png");
          background-size: 100% 100%;
    }
    &.active .dropDown{
      // display: block;
    }
    &.active .title .arrow{
          background: url("../../assets/images/jt2.png");
          background-size: 100% 100%;
    }
    .dropDown .subItem {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2329;
      width: 50%;
      float: left;
      cursor: pointer;
      margin-bottom: 27px;
      &:hover{
        color: rgba(0, 183, 170, 1);
      }
      .icon{
        width: 15px;
        height: 18px;
        margin-right: 4px;
        vertical-align: middle;
      }
    }



  }
}

</style>



// WEBPACK FOOTER //
// src/views/components/Head.vue